<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <form [formGroup]="set_origin_form_group">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'COMPANIES.ORIGIN_COLUMN_LABEL' | translate }}
        </mat-label>
        <mat-select
          formControlName="origin"
          [errorStateMatcher]="error_matcher"
          required>
          <mat-option [value]="mtp">{{ 'COMPANIES.MTP_LABEL' | translate }}</mat-option>
          <mat-option [value]="direct">{{ 'COMPANIES.DIRECT_LABEL' | translate }}</mat-option>
          <mat-option [value]="loans">{{ 'COMPANIES.LOANS_LABEL' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_company_edit_running"
        [is_spinner_visible]="is_company_edit_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
